import React from 'react';
import { Route } from 'react-router-dom';
import UnautorizedPage from '../pages/unautorized';

// @ts-ignore
const PrivateRoute = ({ component: Component,permission, ...rest }) => {
    return ( <Route {...rest} render={props => {
        // @ts-ignore
        if(!permission) {
            return <UnautorizedPage/>
        }

        // authorised so return component
        return <Component {...props} />
    }} /> )
}

export default PrivateRoute;